import React, { useContext, useEffect, useMemo, useState } from "react";
import Switch from "@mui/material/Switch";
import { FormControlLabel } from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  EnumOptionsRemainOrder,
  RetailSettingContext,
} from "../../../services/retail/setting/retailSettingContext";
import { useRouter } from "../../../utils/hooks/useRouter";
import {
  firebaseAndKvaIframeLog,
  firebaseAndKvaLog,
} from "../../../services/analytics/analytic.service";
import { isMobile } from "../../../utils/helper";
import { Snackbar, Spacing } from "kvweb-ui";

const IOSSwitch = styled(
  (props: {
    disabled?: boolean;
    checked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  }) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  )
)(({}) => ({
  width: 50,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "& + .MuiSwitch-track": {
      backgroundColor: "#E5E7E9",
      opacity: 1,
    },
    "&.Mui-checked": {
      transform: "translateX(24px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        border: 0,
        backgroundColor: "#0F93D7",
        "@media (max-width: 600px)": {
          backgroundColor: "#1263A7",
        },
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: "18px",
  },
}));

export default function ProductStoreSwitch() {
  const router = useRouter();
  const [alertOrder, setAlertOrder] = useState(false);

  const {
    productStore,
    updateProductStore,
    rollback,
    initSetting,
    setSynced,
    typeRemainOrder,
  } = useContext(RetailSettingContext);

  const isOrderOnlyRemain = useMemo(() => {
    if (typeRemainOrder === EnumOptionsRemainOrder.infinity) {
      return false;
    }
    return productStore;
  }, [typeRemainOrder, productStore]);

  useEffect(() => {
    updateProductStore && updateProductStore(initSetting.product_store);
    setSynced && setSynced(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rollback]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    trackingSwitchAction(event.target.checked);
    updateProductStore && updateProductStore(event.target.checked);
  };
  const handleSetOrderAlert = () => {
    if (typeRemainOrder === EnumOptionsRemainOrder.infinity)
      setAlertOrder(true);
  };
  const trackingSwitchAction = (checked: boolean) => {
    let eventName = "mk_setting_product";
    if (router.query.platform === "retail") {
      eventName = "kv_mk_setting_product";
      if (isMobile()) {
        eventName = "kvapp_mk_setting_product";
      }
    }
    const action = checked ? "product_on" : "product_off";
    if (isMobile()) {
      firebaseAndKvaLog(router.query.platform, eventName, {
        action,
      });
    } else {
      firebaseAndKvaLog(router.query.platform, eventName, {
        action,
      });
    }
  };

  return (
    <>
      <FormControlLabel
        sx={{ marginRight: 0 }}
        onClick={handleSetOrderAlert}
        control={
          <IOSSwitch
            checked={isOrderOnlyRemain}
            disabled={typeRemainOrder === EnumOptionsRemainOrder.infinity}
            onChange={handleChange}
          />
        }
        label=""
      />
      <Snackbar
        open={alertOrder}
        onClose={() => setAlertOrder(false)}
        autoHideDuration={3000}
        typeAlert={"text"}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        sx={{ marginBottom: Spacing["space-4xxl"] }}
      >
        Vui lòng tắt tính năng “Đặt hàng khi hết tồn kho” để tiếp tục.
      </Snackbar>
    </>
  );
}
